// @ts-check
export class Option{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
//main.die();
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.m = this.main = main;
this.state = state;
this.state.component = 'option';//important, could be setting
/**@type {any}*/this.option$={};
}//

async setDisplay(){
if(this.state.stateObject){
this.option$ = this.state.stateObject;
}//

}//func

async getFormTemplate(){
await this.setDisplay();
let $this = this;//cu
let o = this.option$;//cu
this.optionSection=this.main.pbu.createElement('section',['option']);
///
this.main.pbu.appendChild(this.optionSection,
`
${this.main.pbu.createFormControl({title:"Site Name",value:o.siteName,clasz:['site-name'],required:true,serialize:true})}
${this.main.pbu.createFormControl({title:"Site Alias",value:o.siteAlias,clasz:['site-alias'],required:false,serialize:true})}
${this.main.pbu.createFormControl({title:"Tagline",value:o.tagline,clasz:['tagline'],serialize:true})}
${this.main.pbu.createFormControl({title:"Website",type:'url',value:o.siteUrl,clasz:['site-url'],serialize:true})}
${this.main.pbu.createCheckedInputElement({title:"Theme",type:'radio',value:o.activeTheme,clasz:['active-theme'],items:this.main.config.ACTIVE_THEME,serialize:true})}
<div class="mb-3 row">
<div class="col-md-4 logo-image-trigger d-none"></div>
<div class="col-md-8 logo-image card ${this.main.pbu.showIf(o.logoUrl)}">
<img src="${o.logoUrl}" class="featured-image main-media card-img-top" style="max-height: 50vh;"/>
<div class="delete-media mt-2"></div>
</div>

</div>
`);
//handle
this.siteNameControl=this.optionSection.querySelector('.site-name');//<input>
this.siteAliasControl=this.optionSection.querySelector('.site-alias');//<input>
this.taglineControl=this.optionSection.querySelector('.tagline');//<input>
this.siteUrlControl=this.optionSection.querySelector('.site-url');//<input>
this.activeThemeDiv=this.optionSection.querySelector('.active-theme');//<input>[check]
//images
//logo
this.logoImageTrigger = this.optionSection.querySelector('div.logo-image-trigger');
this.logoImageDiv = this.optionSection.querySelector('div.logo-image');

this.main.media.getMediaTrigger('image',this.logoImageDiv,{title:'Site Logo'}).then(r=>{
    this.main.pbu.replace(this.logoImageTrigger,r,true);
});

addEvents();
return this.optionSection;

async function addEvents(){
//saving
}//inner

//
}//

async save(){
if(! this.main.vu.validate(this.optionSection.querySelectorAll('input.sp-form-control:not([type="radio"])'))){
    return;
}
//let logoImageId = await this.main.media.uploadToServer(this.logoImageDiv.querySelector('div.media-template'));

//don't touch these first properties
let option = {
id:this.option$.id,
siteName:this.siteNameControl.value,
siteAlias:this.siteAliasControl.value,
tagline:this.taglineControl.value,
siteUrl:this.siteUrlControl.value,
activeTheme:this.optionSection.querySelector('input.active-theme:checked').value,
logoUrl:this.logoImageDiv.querySelector('.main-media')?.src||'',
iconUrl:'',
};
this.main.setTenant(option);
this.main.log(option,'Option.saveOption(): Before submit');
let r = await this.main.fu.fetch({
    link:this.main.fu.getApi(this.state.url),
    body:JSON.stringify(option)
});
if(r && r==this.option$.id){
this.main.setCache('option',this.option$);
this.main.setTheme(this.option$);
this.main.utils.notify('Saved',{level:0});
}
this.main.utils.finilizeSave(this);
}//
}//class
